import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import axios from "axios";
// import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
// import VueBootstrapToasts from "vue-bootstrap-toasts";
import Print from "vue-print-nb";
// Vue.use(VueBootstrapToasts);
// Vue.use(BootstrapVue);
// Vue.use(BootstrapVueIcons);
Vue.use(Print);
Vue.config.productionTip = false;

//Load token from local storage
Vue.prototype.$http = axios;
const token = localStorage.getItem("token");

//If there is any token we will append default axios authorisation headers
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
